var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsureSexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.336 10.424C4.408 10.424 3.552 10.2 2.768 9.752C2 9.288 1.384 8.672 0.92 7.904C0.456 7.12 0.224 6.256 0.224 5.312C0.224 4.352 0.456 3.488 0.92 2.72C1.384 1.952 2 1.344 2.768 0.896C3.552 0.431999 4.408 0.199999 5.336 0.199999C6.28 0.199999 7.136 0.431999 7.904 0.896C8.672 1.36 9.288 1.976 9.752 2.744C10.216 3.512 10.448 4.368 10.448 5.312C10.448 6.256 10.216 7.12 9.752 7.904C9.288 8.672 8.672 9.288 7.904 9.752C7.136 10.2 6.28 10.424 5.336 10.424ZM5.336 9.416C6.104 9.416 6.8 9.232 7.424 8.864C8.048 8.48 8.536 7.976 8.888 7.352C9.256 6.728 9.44 6.048 9.44 5.312C9.44 4.544 9.256 3.856 8.888 3.248C8.536 2.624 8.048 2.128 7.424 1.76C6.8 1.392 6.104 1.208 5.336 1.208C4.6 1.208 3.92 1.392 3.296 1.76C2.672 2.112 2.168 2.6 1.784 3.224C1.416 3.848 1.232 4.544 1.232 5.312C1.232 6.08 1.416 6.776 1.784 7.4C2.168 8.008 2.672 8.496 3.296 8.864C3.92 9.232 4.6 9.416 5.336 9.416Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsureSexIcon);
export default __webpack_public_path__ + "static/media/unsure_sex_icon.d3ce832c3c2b90240506138cc26071b4.svg";
export { ForwardRef as ReactComponent };